import { TSyncState } from '@ws/shared/types';

import { openDB, WST_DB_SYNC_STATE_KEY } from '../../modules';

const DB_ACCESS_LEVEL = 'readwrite';

export class iDBActService {
  private static queue: Promise<any> = Promise.resolve();

  public static saveOne(syncState: TSyncState, afterSave?: () => void) {
    const operation = () =>
      openDB()
        .then(async (db) => {
          const transaction = db.transaction(WST_DB_SYNC_STATE_KEY, DB_ACCESS_LEVEL);
          const store = transaction.objectStore(WST_DB_SYNC_STATE_KEY);

          await store.put(syncState);
          // Ждём transaction.done, а не commit() (тот возвращает void): промис должен
          // резолвиться только когда запись durable-зафиксирована. Иначе await у
          // onApplySuccess/onCharge означал бы лишь «commit запрошен», и закрытие
          // вкладки в этом окне теряло бы очередь → повторная отправка (I3 MR-1 C2).
          await transaction.done;
        })
        .then((res) => {
          if (typeof afterSave === 'function') {
            afterSave();
          }

          return res;
        })
        .catch((error) => {
          console.error('Failed to save sync state:', error);
          throw error;
        });

    this.queue = this.queue.then(operation, operation);
    return this.queue;
  }

  public static getOneById(id: string, callback?: (syncState?: TSyncState) => void) {
    return openDB()
      .then((db) => {
        const transaction = db.transaction([WST_DB_SYNC_STATE_KEY], DB_ACCESS_LEVEL);
        const store = transaction.objectStore(WST_DB_SYNC_STATE_KEY);

        return store.get(id) as unknown as TSyncState | undefined;
      })
      .then((res) => {
        if (typeof callback === 'function') {
          callback(res);
        }

        return res as TSyncState | undefined;
      });
  }

  public static removeOne(id: string, callback?: (res?: any) => void) {
    return openDB()
      .then((db) => {
        const transaction = db.transaction([WST_DB_SYNC_STATE_KEY], DB_ACCESS_LEVEL);
        const store = transaction.objectStore(WST_DB_SYNC_STATE_KEY);

        return store.delete(id);
      })
      .then((res) => {
        if (typeof callback === 'function') {
          callback(res);
        }

        return res;
      });
  }
}
